import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import useUser from 'utils/useUser';
import { isAdmin, isAgencyDoctor, isPractice } from 'utils/userTypeHelper';
import { isMobile } from 'utils/deviceHelper';

const generateAddress = (addressArr) =>
  addressArr.filter((el) => !!el).join(', ');

const PatientRow = ({ data }) => {
  const { userType } = useUser();
  const iamAdminOrHHA = useMemo(
    () => isAdmin(userType) || isAgencyDoctor(userType),
    [userType],
  );
  const iamAdminOrHHAOrPractice = useMemo(
    () => isAdmin(userType) || isPractice(userType) || isAgencyDoctor(userType),
    [userType],
  );
  const address = useMemo(
    () => generateAddress([data.addressLine1, data.addressLine2]),
    [data.addressLine1, data.addressLine2],
  );
  const device = useSelector((state) => state.user.deviceType);

  return (
    <tr
      className={
        iamAdminOrHHAOrPractice && data.childClinics?.length > 0
          ? 'clinic-parent-flag'
          : ''
      }
    >
      <td data-label="Clinic">
        <div className="adminPanel__row adminPanel__row--clickable adminPanel__row--center">
          <Link
            data-cy="admin-panel__clinic-link"
            to={`/admin/clinic/${data.guid}`}
          >
            <strong>{data.legalname}</strong>
          </Link>
        </div>
      </td>
      <td data-label="Home Health Agency">
        {iamAdminOrHHA ? (
          <div className="adminPanel__row adminPanel__row--clickable">
            <Link to={`/admin/agency/${data.agency.guid}`}>
              <strong>{data.agency.name}</strong>
            </Link>
          </div>
        ) : (
          <div className="adminPanel__row">
            <strong>{data.agency.name}</strong>
          </div>
        )}
      </td>
      <td data-label="Email">
        <div className="adminPanel__row">
          {data.email}
          {isMobile(device) && !data.email && '-'}
        </div>
      </td>
      <td data-label="Address">
        <div className="adminPanel__row">
          {address}
          {isMobile(device) && !address && '-'}
        </div>
      </td>
      <td data-label="Status">
        <div className="adminPanel__row">
          {data.status
            ? data.status.charAt(0).toUpperCase() + data.status.slice(1)
            : 'Active'}
        </div>
      </td>
    </tr>
  );
};
PatientRow.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default PatientRow;
